// src/pages/DestinationPage.jsx
import { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useLocation } from "react-router-dom";
import SEO from "../components/SEO";
// ── Design tokens ─────────────────────────────────────────────────────────────
const C = {
  dark:  "#1a1a2e",
  gold:  "#f5c518",
  goldD: "#d4a80f",
  white: "#ffffff",
  gray:  "#6b7280",
  grayL: "#9ca3af",
  bg:    "#f8f9fd",
  border:"#e5e7eb",
};
const F = {
  display: "'Playfair Display', serif",
  body:    "'Plus Jakarta Sans', sans-serif",
};

// ── Destination data ──────────────────────────────────────────────────────────
const DEST_DATA = {
  

  Diu: {
  tagline: "Beach Paradise of Gujarat",
  location: "Diu, India",
  distance: "~350 km from Ahmedabad",
  bestTime: "October – March",
  category: "Beach · Travel · Relax",
  timings: "Open All Day",
  entryFee: "Free",
  duration: "1–2 Days",
  rating: 4.7,
  reviews: 2100,
  highlights: [
    "Diu is famous for its clean beaches and Portuguese heritage.",
    "Nagoa Beach is perfect for swimming and relaxing.",
    "Diu Fort offers stunning sea views and history.",
    "Perfect destination for weekend getaway.",
  ],
  tips: [
    "Best time to visit is winter season.",
    "Carry sunscreen and light clothes.",
    "Try local seafood dishes.",
  ],
  nearby: [
    "Nagoa Beach",
    "Diu Fort",
    "INS Khukri Memorial",
    "Ghoghla Beach"
  ],
  color: "#0ea5e9",
},

Porbandar: {
  tagline: "Birthplace of Mahatma Gandhi",
  location: "Porbandar, Gujarat",
  distance: "~400 km from Ahmedabad",
  bestTime: "October – March",
  category: "Heritage · Coastal · Spiritual",
  timings: "9:00 AM – 6:00 PM",
  entryFee: "Free",
  duration: "Half Day – Full Day",
  rating: 4.6,
  reviews: 1800,

  highlights: [
    "Porbandar is the birthplace of Mahatma Gandhi, known as Kirti Mandir.",
    "A peaceful coastal city with scenic sea views.",
    "Sudama Temple is one of the few temples dedicated to Lord Krishna’s friend Sudama.",
    "Beautiful beaches and calm environment perfect for relaxation.",
  ],

  tips: [
    "Visit Kirti Mandir early morning for peaceful experience.",
    "Carry water and sunscreen.",
    "Try local Gujarati food nearby.",
  ],

  nearby: [
    "Kirti Mandir",
    "Sudama Temple",
    "Porbandar Beach",
    "Chowpatty"
  ],

  color: "#0284c7",
},
  Bhavnath: {
    tagline:     "Where Legends Meet the Himalayas of Saurashtra",
    location:    "Junagadh, Gujarat",
    distance:    "~5 km from Junagadh city",
    bestTime:    "November – February",
    category:    "Temple · Festival · Nature",
    timings:     "5:00 AM – 9:00 PM",
    entryFee:    "Free",
    duration:    "2–4 Hours",
    rating:      4.8,
    reviews:     1620,
    highlights:  ["Bhavnath Mahadev Temple sits at the foothills of Mount Girnar, one of the holiest Jain and Hindu pilgrimage sites.", "The temple is dedicated to Lord Shiva and is believed to be thousands of years old.", "The Bhavnath Mela, held during Mahashivaratri, is one of India's most spectacular religious fairs with over 3 lakh pilgrims.", "Naga Sadhus descend from the Girnar hills for this festival — a once-in-a-year spiritual spectacle.", "The surrounding area is lush green with natural springs, peacocks, and misty mountain views.", "It marks the starting point of the iconic Girnar Ropeway and the 10,000-step Girnar Parikrama route."],
    tips:        ["Visit during Mahashivaratri for the unforgettable Bhavnath Mela experience.", "Combine with a Girnar ropeway ride for panoramic views.", "Mornings are coolest — ideal for the Girnar climb.", "Local janta snacks near the entrance are a must-try.", "Respect local customs — maintain silence in the main shrine."],
    nearby:      ["Girnar Ropeway", "Damodar Kund", "Junagadh Wildlife Sanctuary", "Uparkot Fort"],
    color:       "#2e6b3e",
  },
  Dwarka: {
    tagline:     "The Sacred City of Lord Krishna",
    location:    "Devbhoomi Dwarka, Gujarat",
    distance:    "~450 km from Ahmedabad",
    bestTime:    "October – March",
    category:    "Pilgrimage · Heritage · Coastal",
    timings:     "Dwarkadhish Temple: 6:00 AM – 1:00 PM / 5:00 PM – 9:30 PM",
    entryFee:    "Free (temple) · ₹20–50 boat rides",
    duration:    "Full Day",
    rating:      4.9,
    reviews:     5210,
    highlights:  ["Dwarka is one of the Char Dham — four sacred pilgrimage sites for Hindus — and is believed to be the ancient kingdom of Lord Krishna.", "The Dwarkadhish Temple, a 5-storey structure dating back 2,500 years, stands majestically by the Gomti River.", "Beyt Dwarka island, accessible by boat, holds immense religious significance — Lord Krishna is said to have resided here.", "The Gomti Ghat evening aarti is a deeply moving spiritual experience with thousands of devotees.", "Nageshwar Jyotirlinga, one of 12 sacred Shiva temples in India, is just 17 km away.", "Dwarka's coastline offers pristine beaches like Okha Beach and Shivrajpur Beach — perfect after a spiritual day."],
    tips:        ["The Panchkui and Bet Dwarka ferry timings vary — confirm at the ghat.", "Book cab from Dwarka for Nageshwar and Bet Dwarka in one day.", "Temple queues can be long during weekends — visit on weekdays.", "Carry an ID for the ferry.", "Dress conservatively — this is a deeply sacred town."],
    nearby:      ["Nageshwar Jyotirlinga", "Beyt Dwarka", "Rukmini Devi Temple", "Shivrajpur Beach"],
    color:       "#1a5a8a",
  },
  SasanGir: {
    tagline:     "The Last Home of the Asiatic Lion",
    location:    "Junagadh District, Gujarat",
    distance:    "~360 km from Ahmedabad",
    bestTime:    "December – March",
    category:    "Wildlife · Nature · Safari",
    timings:     "Safari: 6:00 AM – 9:00 AM / 3:30 PM – 5:30 PM",
    entryFee:    "₹1,100 – ₹3,300 (Indian / Foreign tourists)",
    duration:    "1–2 Days",
    rating:      4.8,
    reviews:     3480,
    highlights:  ["Gir National Park is the only place in the world outside Africa where you can spot lions in the wild.", "Home to 600+ Asiatic Lions, the park sprawls across 1,412 sq km of dry deciduous forest.", "Beyond lions, spot leopards, hyenas, jackals, 300+ bird species, marsh crocodiles, and sambar deer.", "The Devalia Safari Park offers a guaranteed lion sighting in an enclosed 4 sq km zone — perfect for families.", "Sasan village has several tribal communities — the Maldharis — who have coexisted with lions for generations.", "Night sky views in Gir are spectacular — minimal light pollution makes it ideal for stargazing."],
    tips:        ["Book safaris weeks in advance — slots fill up fast in peak season.", "Early morning safari gives best lion sighting chances.", "Carry binoculars and a zoom camera.", "Stay at a jungle resort for the full experience.", "Park is closed during monsoon (June–October)."],
    nearby:      ["Devalia Safari Park", "Kankai Mata Temple", "Gir Interpretation Zone", "Somnath (65 km)"],
    color:       "#5a7a2e",
  },
  Somanath: {
    tagline:     "First of the Twelve Jyotirlingas",
    location:    "Prabhas Patan, Gujarat",
    distance:    "~7 km from Veraval",
    bestTime:    "October – March",
    category:    "Pilgrimage · Heritage · Coastal",
    timings:     "6:00 AM – 9:30 PM | Aarti: 7 AM, 12 PM, 7 PM",
    entryFee:    "Free",
    duration:    "Half Day – Full Day",
    rating:      4.9,
    reviews:     7230,
    highlights:  ["Somnath Jyotirlinga is the most revered of all 12 Jyotirlingas — a symbol of resilience, having been rebuilt 17 times after invasions.", "The current temple, built in 1951 by Sardar Vallabhbhai Patel, is a masterpiece of Chalukya architecture.", "The famous Somnath Aarti at sunset is one of India's most spiritually charged experiences, held at the shore with the sound of crashing waves.", "A unique pillar at the temple compound points southward with no landmass until Antarctica — a marvel of ancient astronomy.", "Somnath also includes the ruins of the old temple, Triveni Sangam (confluence of 3 rivers), and the Prachi museum.", "The Sound & Light Show every evening narrates the temple's 5,000-year history dramatically."],
    tips:        ["Reach by 6:30 PM for the evening aarti — arrive 30 minutes early.", "Dress in traditional attire — respectful clothing preferred.", "The Sound & Light show is at 8:00 PM and is highly recommended.", "Nearby Prabhas Patan has ancient ruins — explore with a local guide.", "Try fresh seafood at nearby Veraval port market."],
    nearby:      ["Triveni Sangam", "Prachi Museum", "Bhalka Tirth", "Veraval Port"],
    color:       "#8a3a1a",
  },
  JhooltaMinar: {
    tagline:     "The Enigmatic Shaking Minarets of Ahmedabad",
    location:    "Sarangpur, Ahmedabad, Gujarat",
    distance:    "~5 km from Ahmedabad city center",
    bestTime:    "Year-round",
    category:    "Heritage · Architecture · Mystery",
    timings:     "8:00 AM – 6:00 PM (Closed on Fridays for non-Muslims)",
    entryFee:    "Free",
    duration:    "30 Minutes – 1 Hour",
    rating:      4.5,
    reviews:     1190,
    highlights:  ["Jhulta Minar (Shaking Minarets) of Sidi Bashir Mosque are one of India's greatest architectural mysteries, built in the 15th century.", "When one minaret is shaken, the other one — 20+ meters away — vibrates in perfect resonance. The mystery of why has never been solved.", "The intricate stone lattice-work (jaali) on the minarets is extraordinary Indo-Saracenic craftsmanship.", "Sidi Bashir, an Abyssinian slave who served the Gujarat Sultanate, built this mosque as his personal legacy.", "It's a short but incredibly fascinating stop — proof of the genius of medieval Islamic architecture.", "The area around Sarangpur is also home to the iconic Swaminarayan Temple, just 500m away."],
    tips:        ["Visit on a weekday — crowds are minimal.", "The minarets are best viewed in the morning light.", "Combine with Teen Darwaja and Bhadra Fort for a full heritage walk.", "Local tea stalls outside serve excellent chai.", "Respect the religious premises — remove footwear before entering."],
    nearby:      ["Sidi Saiyyed Mosque", "Teen Darwaja", "Bhadra Fort", "Manek Chowk"],
    color:       "#4a3a8a",
  },
};

// ── CSS ───────────────────────────────────────────────────────────────────────
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800;900&family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');
  @keyframes fadeUp   { from{opacity:0;transform:translateY(24px)} to{opacity:1;transform:translateY(0)} }
  @keyframes fadeIn   { from{opacity:0} to{opacity:1} }
  @keyframes slideDown{ from{opacity:0;transform:translateY(-16px)} to{opacity:1;transform:translateY(0)} }
  @keyframes parallax { from{transform:scale(1.08)} to{transform:scale(1)} }
  *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
  html { scroll-behavior:smooth; }
  body { font-family:'Plus Jakarta Sans',sans-serif; overflow-x:hidden; }
  ::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-thumb {
  background: #f5c518;
  border-radius: 10px;
}

  .dest-back-btn:hover { background:rgba(255,255,255,.25) !important; border-color:rgba(255,255,255,.5) !important; }
  .dest-book-btn:hover { transform:translateY(-3px) scale(1.03) !important; box-shadow:0 16px 48px rgba(245,197,24,.55) !important; }
  .highlight-item:hover { background:rgba(245,197,24,.08) !important; border-color:rgba(245,197,24,.3) !important; }
  .tip-item:hover { background:#f0fdf4 !important; }
  .nearby-pill:hover { background:#1a1a2e !important; color:#f5c518 !important; border-color:#1a1a2e !important; }

  @media (max-width:768px) {
    .dest-hero-title { font-size: clamp(28px,7vw,52px) !important; }
    .dest-hero-content { padding: 0 16px 48px !important; }
    .dest-meta-grid { grid-template-columns: 1fr 1fr !important; }
    .dest-main-grid { grid-template-columns: 1fr !important; }
    .dest-section { padding: 40px 16px !important; }
  }
  @media (max-width:480px) {
    .dest-meta-grid { grid-template-columns: 1fr !important; }
  }
`;

// ── Star rating ───────────────────────────────────────────────────────────────
function Stars({ rating }) {
  const safeRating = Number(rating) || 0;   // ✅ FIX
  const full = Math.floor(safeRating);
  const half = safeRating % 1 >= 0.5;

  return (
    <span>
      {[...Array(full)].map((_, i) => (
        <span key={i} style={{ color: "#f5c518" }}>★</span>
      ))}
      {half && <span style={{ color: "#f5c518" }}>½</span>}
    </span>
  );
}

// ── Main component ────────────────────────────────────────────────────────────
export default function DestinationPage({  onBack, onBook }) {
  const { state } = useLocation();
  const destination = state?.destination;
 const data = DEST_DATA[destination?.name] || {};
 const name = destination?.name;
const img = destination?.img;
  const accentColor = data.color || C.gold;
  const [scrollY, setScrollY] = useState(0);
  const [ctaHover, setCtaHover] = useState(false);

  useEffect(() => {
    window.scrollTo({ top:0, behavior:"smooth" });
    const onScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const heroOpacity = Math.max(0, 1 - scrollY / 400);

  return (
    <>
    <SEO page="destination" destination={destination} />
      <style>{CSS}</style>

      <Header />   {/* ✅ ADD HEADER */}

      <div style={{ fontFamily:F.body, background:C.bg, color:C.dark, overflowX:"hidden" }}>

        {/* ══════════ HERO ══════════ */}
        <div style={{ position:"relative", height:"70vh", minHeight:400, overflow:"hidden" }}>
          {/* Parallax image */}
          <img src={img} alt={name}
            style={{ position:"absolute", inset:0, width:"100%", height:"115%", objectFit:"cover", objectPosition:"center", transform:`translateY(${scrollY * 0.35}px)`, transition:"transform .05s linear", animation:"parallax 1.2s ease both" }} />

          {/* Gradient overlay */}
          <div style={{ position:"absolute", inset:0, background:`linear-gradient(to bottom, rgba(0,0,0,.25) 0%, rgba(0,0,0,.15) 40%, rgba(0,0,0,.78) 100%)` }} />

          {/* Sticky back button */}
          {/* <button className="dest-back-btn" onClick={onBack}
            style={{ position:"absolute", top:20, left:20, zIndex:10, display:"flex", alignItems:"center", gap:8, background:"rgba(0,0,0,.35)", backdropFilter:"blur(8px)", border:"1px solid rgba(255,255,255,.25)", color:C.white, borderRadius:50, padding:"10px 20px", fontSize:14, fontWeight:600, fontFamily:F.body, cursor:"pointer", transition:"all .2s", animation:"slideDown .4s ease" }}>
            ← Back
          </button> */}

          {/* Category badge */}
          <div style={{ position:"absolute", top:20, right:20, background:"rgba(0,0,0,.4)", backdropFilter:"blur(8px)", border:`1px solid ${accentColor}55`, borderRadius:50, padding:"6px 16px", fontSize:11, color:accentColor, fontWeight:700, letterSpacing:"1px", textTransform:"uppercase", animation:"slideDown .4s ease" }}>
            {data.category}
          </div>

          {/* Hero text */}
          <div className="dest-hero-content" style={{ position:"absolute", bottom:0, left:0, right:0, padding:"0 40px 56px", animation:"fadeUp .8s .2s ease both", opacity:heroOpacity + 0.2 }}>
            <p style={{ fontSize:13, color:"rgba(255,255,255,.7)", fontWeight:600, letterSpacing:"2px", textTransform:"uppercase", marginBottom:10 }}>📍 {data.location}</p>
            <h1 className="dest-hero-title" style={{ fontFamily:F.display, fontSize:"clamp(32px,6vw,64px)", fontWeight:900, color:C.white, lineHeight:1.1, marginBottom:10, textShadow:"0 4px 24px rgba(0,0,0,.4)" }}>{name}</h1>
            <p style={{ fontSize:"clamp(14px,2vw,18px)", color:"rgba(255,255,255,.85)", fontWeight:400, maxWidth:600 }}>{data.tagline}</p>

            {/* Rating */}
            <div style={{ display:"flex", alignItems:"center", gap:10, marginTop:16 }}>
              <div style={{ display:"flex", alignItems:"center", gap:6, background:"rgba(0,0,0,.4)", backdropFilter:"blur(8px)", borderRadius:50, padding:"6px 16px" }}>
                <Stars rating={data.rating} />
                <span style={{ color:C.white, fontWeight:700, fontSize:14 }}>{data.rating}</span>
                <span style={{ color:"rgba(255,255,255,.5)", fontSize:13 }}>({data.reviews?.toLocaleString()} reviews)</span>
              </div>
              <div style={{ background:`${accentColor}33`, backdropFilter:"blur(8px)", border:`1px solid ${accentColor}55`, borderRadius:50, padding:"6px 16px", fontSize:13, color:C.white, fontWeight:600 }}>
                🕐 {data.duration}
              </div>
            </div>
          </div>
        </div>

        {/* ══════════ META CARDS ══════════ */}
        <div style={{ background:C.dark, padding:"0 24px" }}>
          <div style={{ maxWidth:1100, margin:"0 auto" }}>
            <div className="dest-meta-grid" style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))", gap:0 }}>
              {[
                { icon:"📍", label:"Location",   value:data.location   },
                { icon:"🗓", label:"Best Time",  value:data.bestTime   },
                { icon:"🕐", label:"Timings",    value:data.timings    },
                { icon:"🎟", label:"Entry Fee",  value:data.entryFee   },
                { icon:"🚗", label:"Distance",   value:data.distance   },
                { icon:"⏱", label:"Duration",   value:data.duration   },
              ].map((m,i) => (
                <div key={i} style={{ padding:"20px 16px", borderRight:i<5?"1px solid rgba(255,255,255,.06)":"none", animation:`fadeUp .5s ${i*.08}s ease both` }}>
                  <div style={{ fontSize:18, marginBottom:6 }}>{m.icon}</div>
                  <div style={{ fontSize:10, color:"rgba(255,255,255,.4)", letterSpacing:"1.5px", textTransform:"uppercase", fontWeight:700, marginBottom:4 }}>{m.label}</div>
                  <div style={{ fontSize:13, color:"rgba(255,255,255,.85)", fontWeight:600, lineHeight:1.4 }}>{m.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ══════════ MAIN CONTENT ══════════ */}
        <div style={{ maxWidth:1100, margin:"0 auto", padding:"52px 24px" }}>
          <div className="dest-main-grid" style={{ display:"grid", gridTemplateColumns:"1fr 360px", gap:40, alignItems:"start" }}>

            {/* Left column */}
            <div>
              {/* Highlights */}
              <div className="dest-section" style={{ marginBottom:40 }}>
                <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:24 }}>
                  <div style={{ width:4, height:28, background:`linear-gradient(135deg,${C.gold},${C.goldD})`, borderRadius:2 }} />
                  <h2 style={{ fontFamily:F.display, fontSize:"clamp(20px,3vw,28px)", fontWeight:800, color:C.dark }}>About {name}</h2>
                </div>
                <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
                  {data.highlights?.map((h,i) => (
                    <div key={i} className="highlight-item"
                      style={{ display:"flex", gap:14, alignItems:"flex-start", background:"#f8f9fd", border:"1px solid #e5e7eb", borderRadius:14, padding:"16px 18px", transition:"all .2s", animation:`fadeUp .5s ${i*.06}s ease both` }}>
                      <div style={{ width:28, height:28, borderRadius:8, background:`linear-gradient(135deg,${C.gold},${C.goldD})`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:13, fontWeight:800, color:C.dark, flexShrink:0, marginTop:1 }}>{i+1}</div>
                      <p style={{ fontSize:14, color:"#374151", lineHeight:1.7 }}>{h}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Traveller Tips */}
              <div className="dest-section" style={{ marginBottom:40 }}>
                <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:24 }}>
                  <div style={{ width:4, height:28, background:`linear-gradient(135deg,#22c55e,#16a34a)`, borderRadius:2 }} />
                  <h2 style={{ fontFamily:F.display, fontSize:"clamp(18px,2.5vw,24px)", fontWeight:800, color:C.dark }}>Traveller Tips</h2>
                </div>
                <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                  {data.tips?.map((t,i) => (
                    <div key={i} className="tip-item"
                      style={{ display:"flex", gap:12, alignItems:"flex-start", background:C.white, border:"1px solid #e5e7eb", borderRadius:12, padding:"14px 16px", transition:"background .2s" }}>
                      <span style={{ color:"#22c55e", fontSize:16, marginTop:1, flexShrink:0 }}>✓</span>
                      <p style={{ fontSize:14, color:"#374151", lineHeight:1.6 }}>{t}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Right sidebar */}
            <div style={{ position:"sticky", top:20 }}>

              {/* Nearby card */}
              <div style={{ background:C.white, border:"1px solid #e5e7eb", borderRadius:22, padding:"26px 22px", marginBottom:20, boxShadow:"0 8px 32px rgba(0,0,0,.07)", animation:"fadeUp .6s .3s ease both" }}>
                <h3 style={{ fontFamily:F.display, fontSize:20, fontWeight:800, color:C.dark, marginBottom:16 }}>📌 Nearby Places</h3>
                <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
                  {data.nearby?.map((n,i) => (
                    <span key={i} className="nearby-pill"
                      style={{ background:"#f3f4f6", border:"1px solid #e5e7eb", borderRadius:50, padding:"7px 16px", fontSize:13, fontWeight:600, color:C.dark, cursor:"pointer", transition:"all .2s" }}>
                      {n}
                    </span>
                  ))}
                </div>
              </div>

              {/* Quick facts */}
              <div style={{ background:`linear-gradient(135deg,${C.dark},#2d3a6b)`, borderRadius:22, padding:"26px 22px", marginBottom:20, boxShadow:"0 8px 32px rgba(0,0,0,.15)", animation:"fadeUp .6s .4s ease both" }}>
                <h3 style={{ fontFamily:F.display, fontSize:18, fontWeight:800, color:C.white, marginBottom:18 }}>⚡ Quick Facts</h3>
                {[
                  { label:"Best Season",  val:data.bestTime  },
                  { label:"Entry",        val:data.entryFee  },
                  { label:"Category",     val:data.category  },
                  { label:"Visit Duration",val:data.duration },
                ].map(({label,val},i) => (
                  <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", padding:"10px 0", borderBottom:i<3?"1px solid rgba(255,255,255,.08)":"none", gap:12 }}>
                    <span style={{ fontSize:12, color:"rgba(255,255,255,.45)", fontWeight:600, textTransform:"uppercase", letterSpacing:".5px", flexShrink:0 }}>{label}</span>
                    <span style={{ fontSize:13, color:C.white, fontWeight:600, textAlign:"right" }}>{val}</span>
                  </div>
                ))}
              </div>

              {/* Rating card */}
              <div style={{ background:`linear-gradient(135deg,${accentColor}18,${accentColor}08)`, border:`1px solid ${accentColor}33`, borderRadius:22, padding:"22px", animation:"fadeUp .6s .5s ease both" }}>
                <div style={{ textAlign:"center" }}>
                  <div style={{ fontFamily:F.display, fontSize:52, fontWeight:900, color:accentColor, lineHeight:1 }}>{data.rating}</div>
                  <div style={{ fontSize:22, marginTop:6, marginBottom:4 }}><Stars rating={data.rating} /></div>
                  <div style={{ fontSize:13, color:C.gray }}>{data.reviews?.toLocaleString()} verified reviews</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ══════════ STICKY BOOK NOW BANNER ══════════ */}
        {/* <div style={{ position:"sticky", bottom:0, zIndex:50, background:"rgba(255,255,255,.97)", backdropFilter:"blur(20px)", borderTop:"1px solid #e5e7eb", boxShadow:"0 -8px 32px rgba(0,0,0,.1)", padding:"16px 24px" }}>
          <div style={{ maxWidth:1100, margin:"0 auto", display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:14 }}>
            <div>
              <div style={{ fontFamily:F.display, fontSize:"clamp(16px,2.5vw,22px)", fontWeight:800, color:C.dark }}>{name}</div>
              <div style={{ fontSize:13, color:C.gray, marginTop:2 }}>📍 {data.location} · ⭐ {data.rating} rated</div>
            </div>
            <button
              className="dest-book-btn"
              onClick={() => onBook && onBook(name)}
              onMouseEnter={() => setCtaHover(true)}
              onMouseLeave={() => setCtaHover(false)}
              style={{ background:`linear-gradient(135deg,${ctaHover?"#ffd700":C.gold},${C.goldD})`, color:C.dark, border:"none", borderRadius:50, padding:"15px 52px", fontSize:"clamp(15px,2vw,18px)", fontWeight:800, fontFamily:F.display, cursor:"pointer", boxShadow:"0 6px 28px rgba(245,197,24,.4)", transition:"all .3s", letterSpacing:".4px", whiteSpace:"nowrap" }}>
              🚗 Book a Cab to {name}
            </button>
          </div>
        </div> */}

      </div>
      <Footer />   {/* ✅ ADD FOOTER */}
    </>
  );
}